import {
  UPDATE_PPO_DATA,
  UPDATE_PPO_DATA_LOADING,
  UPDATE_PPO_STATE,
  UPDATE_PPO_STATE_LOADING,
  UPDATE_STYLEBOARD_INFO,
  UPDATE_STYLEBOARD_INFO_LOADING,
  SET_FETCH_STYLEBOARDINFO,
  UPDATE_STYLEBOARD,
  UPDATE_STYLEBOARD_LOADING,
  UPDATE_STYLEBOARD_V2,
  SET_FETCH_SPACEDATA,
  SET_PHOTO_SUBMIT_SUCCESS,
  SET_PHOTO_WARNING,
  SET_PHOTOS_UPLOADING,
  SET_PHOTOS_UPLOAD_TOTAL,
  SET_PHOTOS_UPLOAD_CURRENT,
  UPDATE_PHOTOS_AND_MEASUREMENTS,
  UPDATE_PHOTOS_AND_MEASUREMENTS_LOADING,
  UPDATE_PRODUCT_CATEGORIES,
  UPDATE_PRODUCT_CATEGORIES_LOADING,
  UPDATE_ABOUT_YOU,
  UPDATE_ABOUT_YOU_LOADING,
  UPDATE_ABOUT_YOU_SUBMITTING,
  SET_STYLEBOARD_SUBMIT_SUCCESS,
  SET_STYLEBOARD_SUBMIT_ERROR,
  SET_STYLEBOARD_SUBMIT_LOADING,
  UPDATE_SPACE_LIST,
  UPDATE_SPACE_LIST_LOADING,
  SET_SPACELIST_PAGE,
  SET_SPACE_USER_ID,
  SET_SPACE_USER_ID_LOADING,
  SET_STYLE_MATCH_QUIZ_COMPLETE,
  SET_STYLE_MATCH_QUIZ_COMPLETE_LOADING,
  SET_LEGACY_QUIZ_RESULT,
  SET_LEGACY_QUIZ_RESULT_LOADING
} from './action-constants';

// =======
// REDUCER
// =======

// Redux best practice is to keep state minimal and normalized.
// So we should try and store objects with unique keys instead of nested.
// We should also keep the minimum state possible. If we can compute something
// from existing state then that logic should go into a selector and we can
// use reselect for memoization if the computation is expensive.
const initialState = {
  aboutYouData: {},
  aboutYouDataLoading: false,
  aboutYouDataSubmitting: false,
  ppoData: {},
  ppoState: {},
  photosAndMeasurementData: null,
  photosAndMeasurementDataLoading: false,
  photosSubmitSuccess: true,
  photosSubmitError: '',
  photosSubmitWarning: '',
  photosUploading: false,
  photosUploadTotal: 0,
  photosUploadCurrent: 0,
  productCategoriesData: {},
  productCategoriesDataLoading: false,
  shouldFetchStyleboardInfo: true,
  styleboardInfo: {},
  styleboardInfoLoading: false,
  shouldFetchSpaceData: true,
  styleboard: {},
  styleboardLoading: false,
  styleboardSubmitSuccess: false,
  styleboardSubmitLoading: false,
  styleboardSubmitError: '',
  styleboardV2: {},
  spaceList: {},
  spaceListLoading: false,
  spaceListPage: 1,
  spaceUserId: -1,
  spaceUserIdLoading: false,
  styleMatchQuizComplete: false,
  styleMatchQuizCompleteLoading: false,
  legacyStyleQuizResult: {},
  legacyStyleQuizResultLoading: false
};

export const ppoReducerKey = 'ppoData';
export const ppoReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case UPDATE_STYLEBOARD_INFO:
      const styleboardInfo = action.payload;
      // We do need these values for space creation,
      // however we do not want to update them because BE handles it next.
      if (styleboardInfo) {
        styleboardInfo.budgetMax = 0;
        styleboardInfo.budgetMin = 0;
      }
      return { ...state, styleboardInfo };
    case UPDATE_STYLEBOARD_INFO_LOADING:
      const styleboardInfoLoading = action.payload;
      return { ...state, styleboardInfoLoading };
    case SET_FETCH_STYLEBOARDINFO:
      const shouldFetchStyleboardInfo = action.payload;
      return { ...state, shouldFetchStyleboardInfo };

    case UPDATE_STYLEBOARD:
      const styleboard = action.payload;
      return { ...state, styleboard };
    case UPDATE_STYLEBOARD_LOADING:
      const styleboardLoading = action.payload;
      return { ...state, styleboardLoading };

    case UPDATE_PPO_DATA:
      const ppoData = action.payload;
      return { ...state, ppoData };
    case UPDATE_PPO_DATA_LOADING:
      const ppoDataLoading = action.payload;
      return { ...state, ppoDataLoading };

    case UPDATE_PPO_STATE:
      const ppoState = action.payload;
      return { ...state, ppoState };
    case UPDATE_PPO_STATE_LOADING:
      const ppoStateLoading = action.payload;
      return { ...state, ppoStateLoading };

    case SET_FETCH_SPACEDATA:
      const shouldFetchSpaceData = action.payload;
      return { ...state, shouldFetchSpaceData };
    case UPDATE_STYLEBOARD_V2:
      const styleboardV2 = action.payload;
      return { ...state, styleboardV2 };

    case SET_PHOTO_SUBMIT_SUCCESS:
      const photosSubmitSuccess = action.payload.success;
      const photosSubmitError = action.payload.error;
      return { ...state,
        photosSubmitSuccess,
        photosSubmitError
      };
    case SET_PHOTO_WARNING:
      const photosSubmitWarning = action.payload.warning;
      return { ...state,
        photosSubmitWarning
      };
    case SET_PHOTOS_UPLOADING:
      const photosUploading = action.payload;
      return { ...state, photosUploading };
    case SET_PHOTOS_UPLOAD_TOTAL:
      const photosUploadTotal = action.payload;
      return { ...state, photosUploadTotal };
    case SET_PHOTOS_UPLOAD_CURRENT:
      const photosUploadCurrent = action.payload;
      return { ...state, photosUploadCurrent };

    case UPDATE_PHOTOS_AND_MEASUREMENTS:
      const photosAndMeasurementData = action.payload;
      return { ...state, photosAndMeasurementData };
    case UPDATE_PHOTOS_AND_MEASUREMENTS_LOADING:
      const photosAndMeasurementDataLoading = action.payload;
      return { ...state, photosAndMeasurementDataLoading };

    case UPDATE_PRODUCT_CATEGORIES:
      const productCategoriesData = action.payload;
      return { ...state, productCategoriesData };
    case UPDATE_PRODUCT_CATEGORIES_LOADING:
      const productCategoriesDataLoading = action.payload;
      return { ...state, productCategoriesDataLoading };

    case UPDATE_ABOUT_YOU:
      const aboutYouData = action.payload;
      return { ...state, aboutYouData };
    case UPDATE_ABOUT_YOU_LOADING:
      const aboutYouDataLoading = action.payload;
      return { ...state, aboutYouDataLoading };
    case UPDATE_ABOUT_YOU_SUBMITTING:
      const aboutYouDataSubmitting = action.payload;
      return { ...state, aboutYouDataSubmitting };

    case SET_STYLEBOARD_SUBMIT_LOADING:
      const isLoading = action.payload;
      return {
        ...state,
        styleboardSubmitLoading: isLoading
      };
    case SET_STYLEBOARD_SUBMIT_SUCCESS:
      const isSuccessful = action.payload;
      return {
        ...state,
        styleboardSubmitSuccess: isSuccessful,
        styleboardSubmitLoading: false,
        styleboardSubmitError: ''
      };
    case SET_STYLEBOARD_SUBMIT_ERROR:
      const errorMessage = action.payload;
      return {
        ...state,
        styleboardSubmitSuccess: false,
        styleboardSubmitLoading: false,
        styleboardSubmitError: errorMessage
      };

    case UPDATE_SPACE_LIST:
      const { spaceList, spaceListPage } = action.payload;
      return {
        ...state,
        spaceList: {...state.spaceList, ...spaceList},
        spaceListPage
      };
    case UPDATE_SPACE_LIST_LOADING:
      const spaceListLoading = action.payload;
      return {
        ...state,
        spaceListLoading
      };
    case SET_SPACELIST_PAGE:
      const page = action.payload;
      return {
        ...state,
        spaceListPage: page
      };

    case SET_SPACE_USER_ID:
      const spaceUserId = action.payload;
      return {
        ...state,
        spaceUserId
      };
    case SET_SPACE_USER_ID_LOADING:
      const spaceUserIdLoading = action.payload;
      return {
        ...state,
        spaceUserIdLoading
      };

    case SET_STYLE_MATCH_QUIZ_COMPLETE:
      const styleMatchQuizComplete = action.payload;

      // Mark style quiz completed.
      let updatedStyleboard = state.styleboard;
      if (styleMatchQuizComplete) {
        updatedStyleboard = {
          ...updatedStyleboard,
          dashboard: {
            ...updatedStyleboard.dashboard,
            stylequiz: {
              ...updatedStyleboard.dashboard.stylequiz,
              status: 'completed'
            }
          }
        };
      }

      return {
        ...state,
        styleboard: updatedStyleboard,
        styleMatchQuizComplete
      };
    case SET_STYLE_MATCH_QUIZ_COMPLETE_LOADING:
      const styleMatchQuizCompleteLoading = action.payload;
      return {
        ...state,
        styleMatchQuizCompleteLoading
      };

    case SET_LEGACY_QUIZ_RESULT:
      const legacyStyleQuizResult = action.payload;
      return {
        ...state,
        legacyStyleQuizResult
      };

    case SET_LEGACY_QUIZ_RESULT_LOADING:
      const legacyStyleQuizResultLoading = action.payload;
      return {
        ...state,
        legacyStyleQuizResultLoading
      };

    default:
      return state;
  }
};
